import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useSettingsContext } from '../contexts/settings.context';
export function ErrorHint({ message }) {
    const { translate } = useSettingsContext();
    return (_jsxs(_Fragment, { children: [_jsx("p", Object.assign({ className: "text-dfxRed-100" }, { children: translate('general/errors', 'Something went wrong. Please try again. If the issue persists please reach out to our support.') })), _jsx("p", Object.assign({ className: "text-dfxGray-800 text-sm" }, { children: message }))] }));
}
